/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withoutUndefinedValues } from "@pagopa/ts-commons/lib/types";
import {
  RequestParams,
  TypeofApiCall,
  TypeofApiParams,
  createFetchRequestForApi,
  ReplaceRequestParams
} from "@pagopa/ts-commons/lib/requests";
import { identity } from "fp-ts/lib/function";

import {
  AuthLoginT,
  authLoginDefaultDecoder,
  AuthUsersT,
  authUsersDefaultDecoder,
  AuthLogoutT,
  authLogoutDefaultDecoder,
  AuthenticateWithAuthTokenT,
  authenticateWithAuthTokenDefaultDecoder
} from "./requestTypes";

// This is a placeholder for undefined when dealing with object keys
// Typescript doesn't perform well when narrowing a union type which includes string and undefined
// (example: "foo" | "bar" | undefined)
// We use this as a placeholder for type parameters indicating "no key"
type __UNDEFINED_KEY = "_____";

export type ApiOperation = TypeofApiCall<AuthLoginT> &
  TypeofApiCall<AuthUsersT> &
  TypeofApiCall<AuthLogoutT> &
  TypeofApiCall<AuthenticateWithAuthTokenT>;

export type ParamKeys = keyof (TypeofApiParams<AuthLoginT> &
  TypeofApiParams<AuthUsersT> &
  TypeofApiParams<AuthLogoutT> &
  TypeofApiParams<AuthenticateWithAuthTokenT>);

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type OmitApiCallParams<
  ApiT,
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = (
  op: TypeofApiCall<ApiT>
) => K extends __UNDEFINED_KEY
  ? TypeofApiCall<ApiT>
  : TypeofApiCall<ReplaceRequestParams<ApiT, Omit<RequestParams<ApiT>, K>>>;

/**
 * Defines an adapter for TypeofApiCall which omit one or more parameters in the signature
 * @param ApiT the type which defines the operation to expose
 * @param K the parameter to omit. undefined means no parameters will be omitted
 */
export type WithDefaultsT<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = OmitApiCallParams<
  AuthLoginT | AuthUsersT | AuthLogoutT | AuthenticateWithAuthTokenT,
  K
>;

/**
 * Defines a collection of api operations
 * @param K name of the parameters that the Clients masks from the operations
 */
export type Client<
  K extends ParamKeys | __UNDEFINED_KEY = __UNDEFINED_KEY
> = K extends __UNDEFINED_KEY
  ? {
      readonly authLogin: TypeofApiCall<AuthLoginT>;

      readonly authUsers: TypeofApiCall<AuthUsersT>;

      readonly authLogout: TypeofApiCall<AuthLogoutT>;

      readonly authenticateWithAuthToken: TypeofApiCall<
        AuthenticateWithAuthTokenT
      >;
    }
  : {
      readonly authLogin: TypeofApiCall<
        ReplaceRequestParams<AuthLoginT, Omit<RequestParams<AuthLoginT>, K>>
      >;

      readonly authUsers: TypeofApiCall<
        ReplaceRequestParams<AuthUsersT, Omit<RequestParams<AuthUsersT>, K>>
      >;

      readonly authLogout: TypeofApiCall<
        ReplaceRequestParams<AuthLogoutT, Omit<RequestParams<AuthLogoutT>, K>>
      >;

      readonly authenticateWithAuthToken: TypeofApiCall<
        ReplaceRequestParams<
          AuthenticateWithAuthTokenT,
          Omit<RequestParams<AuthenticateWithAuthTokenT>, K>
        >
      >;
    };

/**
 * Create an instance of a client
 * @param params hash map of parameters thata define the client:
 *  - baseUrl: the base url for every api call (required)
 *  - fetchApi: an implementation of the fetch() web API, depending on the platform (required)
 *  - basePath: optional path to be appended to the baseUrl
 *  - withDefaults: optional adapter to be applied to every operation, to omit some paramenters
 * @returns a collection of api operations
 */
export function createClient<K extends ParamKeys>(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults: WithDefaultsT<K>;
  basePath?: string;
}): Client<K>;
export function createClient(params: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: undefined;
  basePath?: string;
}): Client;
export function createClient<K extends ParamKeys>({
  baseUrl,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi,
  withDefaults,
  basePath = "/"
}: {
  baseUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fetchApi: typeof fetch;
  withDefaults?: WithDefaultsT<K>;
  basePath?: string;
}) {
  const options = {
    baseUrl,
    fetchApi
  };

  const authLoginT: ReplaceRequestParams<
    AuthLoginT,
    RequestParams<AuthLoginT>
  > = {
    method: "get",

    headers: ({ ["x-rpt-ids"]: xRptIds }) => ({
      "x-rpt-ids": xRptIds
    }),
    response_decoder: authLoginDefaultDecoder(),
    url: ({}) => `${basePath}/auth/login`,

    query: ({ ["recaptcha"]: recaptcha }) =>
      withoutUndefinedValues({ ["recaptcha"]: recaptcha })
  };
  const authLogin: TypeofApiCall<AuthLoginT> = createFetchRequestForApi(
    authLoginT,
    options
  );

  const authUsersT: ReplaceRequestParams<
    AuthUsersT,
    RequestParams<AuthUsersT>
  > = {
    method: "get",

    headers: ({ ["bearerAuth"]: bearerAuth, ["x-rpt-ids"]: xRptIds }) => ({
      Authorization: `Bearer ${bearerAuth}`,

      "x-rpt-ids": xRptIds
    }),
    response_decoder: authUsersDefaultDecoder(),
    url: ({}) => `${basePath}/auth/users`,

    query: () => withoutUndefinedValues({})
  };
  const authUsers: TypeofApiCall<AuthUsersT> = createFetchRequestForApi(
    authUsersT,
    options
  );

  const authLogoutT: ReplaceRequestParams<
    AuthLogoutT,
    RequestParams<AuthLogoutT>
  > = {
    method: "post",

    headers: ({ ["bearerAuth"]: bearerAuth, ["x-rpt-ids"]: xRptIds }) => ({
      Authorization: `Bearer ${bearerAuth}`,

      "x-rpt-ids": xRptIds,

      "Content-Type": "application/json"
    }),
    response_decoder: authLogoutDefaultDecoder(),
    url: ({}) => `${basePath}/auth/logout`,

    body: () => "{}",

    query: () => withoutUndefinedValues({})
  };
  const authLogout: TypeofApiCall<AuthLogoutT> = createFetchRequestForApi(
    authLogoutT,
    options
  );

  const authenticateWithAuthTokenT: ReplaceRequestParams<
    AuthenticateWithAuthTokenT,
    RequestParams<AuthenticateWithAuthTokenT>
  > = {
    method: "post",

    headers: ({ ["x-rpt-ids"]: xRptIds }) => ({
      "x-rpt-ids": xRptIds,

      "Content-Type": "application/json"
    }),
    response_decoder: authenticateWithAuthTokenDefaultDecoder(),
    url: ({}) => `${basePath}/auth/token`,

    body: ({ ["body"]: body }) =>
      body?.constructor?.name === "Readable" ||
      body?.constructor?.name === "ReadableStream"
        ? (body as ReadableStream)
        : body?.constructor?.name === "Buffer"
        ? (body as Buffer)
        : JSON.stringify(body),

    query: () => withoutUndefinedValues({})
  };
  const authenticateWithAuthToken: TypeofApiCall<AuthenticateWithAuthTokenT> = createFetchRequestForApi(
    authenticateWithAuthTokenT,
    options
  );

  return {
    authLogin: (withDefaults || identity)(authLogin),
    authUsers: (withDefaults || identity)(authUsers),
    authLogout: (withDefaults || identity)(authLogout),
    authenticateWithAuthToken: (withDefaults || identity)(
      authenticateWithAuthToken
    )
  };
}
